"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const ConfirmDialog = ({ title, message, cancelLabel, confirmLabel, open, prompt, multiline, placeholder, loading, onCancel, onConfirm }) => {
    const [response, setResponse] = (0, react_1.useState)('');
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null, title),
        react_1.default.createElement(core_1.DialogContent, null,
            typeof message === 'string' ? (react_1.default.createElement(core_1.Typography, { variant: 'body2', gutterBottom: true }, message)) : (message),
            prompt && (react_1.default.createElement(core_1.TextField, { fullWidth: true, multiline: multiline, variant: 'outlined', placeholder: placeholder, value: response, onChange: event => setResponse(event.target.value) }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onCancel }, cancelLabel || 'Cancel'),
            react_1.default.createElement(core_1.Button, { variant: 'contained', color: 'primary', disabled: prompt && response.length === 0, endIcon: loading && react_1.default.createElement(core_1.CircularProgress, { size: 24 }), onClick: () => {
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(prompt ? response : undefined);
                } }, confirmLabel || 'OK'))));
};
exports.ConfirmDialog = ConfirmDialog;
exports.default = exports.ConfirmDialog;
//# sourceMappingURL=ConfirmDialog.js.map